import styled, { css } from 'styled-components';

interface QuestionItem {
  idx: string;
  title: string;
  answser: string;
}

interface Props {
  questions: QuestionItem[];
  isSmallAnswer?: boolean;
}

function Question({ questions, isSmallAnswer }: Props) {
  return (
    <Container>
      {questions.map((item) => (
        <>
          <Content key={item.idx}>
            <QuestionNumber>Question {item.idx}</QuestionNumber>
            <QuestionTitle>{item.title}</QuestionTitle>
            <QuestionAnswer $isSmall={isSmallAnswer}>
              {item.answser}
            </QuestionAnswer>
          </Content>
          {item.idx !== '05' && <Divider />}
        </>
      ))}
    </Container>
  );
}

export default Question;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  align-self: stretch;
`;

const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: #c8c8d2;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const QuestionNumber = styled.div`
  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const QuestionTitle = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const QuestionAnswer = styled.div<{ $isSmall?: boolean }>`
  color: #2f2e2e;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      color: #484848;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 145%; /* 23.2px */
      letter-spacing: -0.32px;
    `}
`;
